import {Component, Input} from '@angular/core';

/** Espelha TesteDoLead do servidor (AcessoLinkGestorIa): links que a Mia mandou ao criar o teste e quando o lead abriu. */
export interface AcessoAoLink { primeiroEm: string; ultimoEm: string; acessos: number; }
export interface PassoDoLead { id: string; nome: string; feito: boolean; iniciado: boolean; detalhe: string; }
export interface TesteDoLead {
  empresaId: number;
  loja: string | null;
  painel: string | null;
  acessos: {painel: AcessoAoLink | null; loja: AcessoAoLink | null};
  /** primeiros passos do painel (/admin/comecar); null quando a loja não está no onboarding guiado */
  onboarding?: {feitos: number; total: number; concluido: boolean; fase: string; passos: PassoDoLead[]} | null;
}

/**
 * Links do teste: URL da loja e do painel, com cópia, se o lead já abriu cada um pelo link da Mia
 * e os primeiros passos que ele já fez no painel.
 * O painel abre com ?equipe=1: a equipe entra na conta do lead sem contar como acesso dele.
 * Usado na gaveta do kanban de leads e na ficha da tela Comercial.
 */
@Component({
  selector: 'app-links-teste-gestor',
  templateUrl: './links-teste-gestor.component.html',
  styleUrls: ['./links-teste-gestor.component.scss'],
})
export class LinksTesteGestorComponent {
  @Input() teste: TesteDoLead | null = null;
  copiado: string | null = null;
  private timer: any;

  semProtocolo(url: string): string { return String(url || '').replace(/^https?:\/\//, '').replace(/\/$/, ''); }
  /** o painel mostra só o domínio: o token do link é longo e não diz nada para quem lê */
  dominio(url: string): string { return this.semProtocolo(url).split('/')[0]; }
  linkDaEquipe(url: string): string { return url + (url.includes('?') ? '&' : '?') + 'equipe=1'; }

  copie(qual: string) {
    const url = qual === 'loja' ? this.teste?.loja : this.teste?.painel;
    if (!url) return;
    navigator.clipboard?.writeText(url).then(() => {
      this.copiado = qual;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.copiado = null, 1600);
    });
  }
}
